import type { ReactElement } from "react";

import { Quotes } from "../../Icons";

export const Testimony = ({
  className,
  children,
}: {
  className: string;
  children: ReactElement;
}) => (
  <div className={className}>
    <div className="flex h-12 w-12 items-center justify-center rounded-full bg-clear-sky-base">
      <Quotes className="h-4 w-4 fill-new-beginnings-base" />
    </div>
    {children}
  </div>
);
